import * as React from 'react';
/**
 *
 * Original name: settings
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1257
 *
 */
export const SettingsFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M18 12c0-.15-.005-.3-.015-.463l1.389-1.765-1.758-3.045-1.989.287a5.47 5.47 0 0 0-1.09-.565L13.758 4.5h-3.516l-.78 1.95a5.47 5.47 0 0 0-1.09.565l-1.989-.286-1.757 3.043 1.389 1.765a7.442 7.442 0 0 0 0 .925l-1.389 1.766 1.758 3.045 1.989-.287c.34.229.707.418 1.09.565l.779 1.949h3.515l.78-1.95c.383-.147.75-.337 1.09-.565l1.99.287 1.757-3.045-1.389-1.764A7.47 7.47 0 0 0 18 12Zm-6 3a2.812 2.812 0 0 1-3-3 2.812 2.812 0 0 1 3-3 2.811 2.811 0 0 1 3 3 2.81 2.81 0 0 1-3 3Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
